import React, { FormEvent, useEffect, useMemo, useState } from "react";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { SearchSelectWithEnum } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { useSearchRegisteredScrapperQuery, useToggleWorkerDisabledStatusMutation } from "../workerScraperApi";

const RegisteredScrapers = () => {

    useEffect(() => {
        document.title = 'Registered Scrapers';
    }, []);
    const [showToggleDisableModal, setShowToggleDisableModal] = useState(false);
    const [workerId, setWorkerId] = useState(null);
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Registered Scrapers", url: "" }]
    )
    const [toggleWorkerStatus, { isLoading: toggleWorkerStatusApiResponse }] = useToggleWorkerDisabledStatusMutation();
    const { data: enums } = useGetEnumsQuery("");
    const toggleWorker = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (e) {
            return toggleWorkerStatus(workerId);
        }
    }
    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <>
                    <span title={props.value}>{props.value}</span>
                </>
            }
        },
        {
            label: "Host Name", accessor: "hostName", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <>
                    <span title={props.value}>{props.value}</span>
                </>
            }
        },
        {
            label: "Status", accessor: "status",
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["WorkerStatus"], "Select Worker Status(es)...", true, "statuses"),
                overrideFilterLabel: "Worker Status(es)",
                overrideFilterAccessor: "statuses"
            }],
        },
        {
            label: "Supported Modules", accessor: "supportedModules", canSort: false,
            cell: (props: any) => {
                let content = props.row.original.supportedModules.map((curModule: any) => {
                    return `'${curModule.name}'`;
                }).join(", ");
                return (
                    <span
                        className="inline-block w-[200px] whitespace-nowrap overflow-hidden text-ellipsis absolute"
                        title={content}
                    >
                        {content}
                    </span>
                );
            },
        },
        {
            label: "Alive Since", accessor: "creationDate",
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.creationDate);
            }
        },
        {
            label: "Toggle Disabled Status", accessor: "random", canSort:false,
            cell: (props: any) => {
                const icon = `fas ${props.row.original.status === getEnumDisplayNameByConstant(enums?.["WorkerStatus"], "DISABLED") ?
                    "fa-play ml-5" :
                    "fa-pause ml-5"}`;
                return <>
                    <i className={icon} onClick={(e) => {
                        setWorkerId(props.row.original.id)
                        setShowToggleDisableModal(true);
                    }
                    } />
                </>
            }
        },
    ]
    return (
        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchRegisteredScrapperQuery,
                    exportAction: null
                }}
                userSettingGroup={"Registered Scraper"}
            />
            {showToggleDisableModal
                && <ConfirmationModal title={"Toggle Disable Status"}
                    bodyMessage={"Are you sure you want to toggle disable status?"}
                    onSubmit={toggleWorker}
                    show={showToggleDisableModal}
                    setShow={setShowToggleDisableModal}
                    isLoading={toggleWorkerStatusApiResponse} />}
        </div>
    );
};
export default RegisteredScrapers;
